import { API, axiosInstance } from "lib";

// chart of account
export const getChartOfAccountList = (data = {}) => {
    return axiosInstance
        .post(API.GET_CHART_ACCOUNT_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

export const getChartOfAccountDetails = (data = {}) => {
    return axiosInstance
        .post(API.GET_CHART_OF_ACCOUNT_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
         
        });
};

// Delete chart of account
export const deleteChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.DELETE_CHART_OF_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            
        });
};
// update chart of account
export const updateChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.EDIT_CHART_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            // throw err;
        });
};
export const createChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.CREATE_CHART_OF_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
         
        });
};

export const updateApproveStatus = (data = {}) => {
    return axiosInstance
        .post(API.UPDATE_APPROVE, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            
        });
};

export const getDropDownChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.GET_CHART_OF_ACCOUNT_TYPE_WISE, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
           
        });
};


export const updateCharOfAccountCategory = (data = {}) => {
    return axiosInstance
        .post(API.UPDATE_CHAROF_EXPENSE_CATEGORY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            
        });
};

export const deleteCharOfAccountCategory = (data = {}) => {
    return axiosInstance
        .post(API.DELETE_CHAROF_EXPENSE_CATEGORY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            
        });
};

export const getMoneyInListApi = (data = {}) => {
    return axiosInstance
        .post(API.MONEY_IN, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            
        });
};

export const getMoneyOutListApi = (data = {}) => {
    return axiosInstance
        .post(API.MONEY_OUT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            
        });
};


export const getVoucherReport = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_VOUCHER_REPORT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getFuelReport = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_FUEL_REPORT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};
